type ViewJoinCountSource = {
  join_count?: number;
  joins?: unknown[];
};

export function getViewJoinCount(view: ViewJoinCountSource): number {
  return view.join_count ?? view.joins?.length ?? 0;
}
